import React from "react"
import { PageProps } from "gatsby"
import { useIntl } from "gatsby-plugin-intl"
import * as styles from "./movie-teller.module.scss"

import SEO from "../../../components/seo"
import ProjectLayout from "../../../templates/project-page/ProjectLayout"
import ProjectGrid from "../../../components/UI/ProjectGrid"

const MovieTeller: React.FC<PageProps> = ({ location }) => {
	const intl = useIntl()

	const solutionDescription = <div>
		<h2>Solution Description</h2>
		<p>A system that predicts TV series’ popularity at the stage of the idea and enables one to choose the TV series with the highest potential.</p>
	</div>

	return (
		<ProjectLayout
			title={intl.formatMessage({
				id: "projects.movie-teller.banner.title",
			})}
			date="2020-2021"
			desktopImage="/images/projects/movie-teller/banner.png"
			mobileImage="/images/projects/movie-teller/banner-m.png"
			description={solutionDescription}
			client="Major Russian media channel producing TV and video content."
			expretise={`Full-cycle development \nAnalytics`}
			location={location}
			back="white"
		>
			<SEO
				language={intl.locale}
				description={intl.formatMessage({ id: "projects-new.list.mt.description" })}
				title={intl.formatMessage({ id: "projects-new.list.mt.metatitle" })}
				pathname={location.pathname}
			/>
			{/* Дополнительный контент */}
			<section className={styles.tech}>
				<h2>Technology Background</h2>
				<div className={styles.techSubtitle}>
					<p>Inventale’s massive experience in working with Big Data and accounting numerous events and adjustments is the basis of this project (apart from data mining and machine learning).
					</p>
				</div>
				<p><strong>The steps made to implement the project include:</strong></p>
				<div className={styles.techGrid}>
					<p><strong>Compilation and processing of data on<br /> movies and series from IMDb website</strong></p>
					<p><strong>Training of various Random Forest<br /> combinations using H2O in R</strong></p>
					<div>
						<p><strong>Analysis of the resulting hundreds <br />of parameters such as:</strong></p>
						<ul>
							<li>genres and settings;</li>
							<li>cast and film directors; </li>
							<li>the correlation between the year of<br /> release and the film or series rating;</li>
							<li>the temporal genre popularity;</li>
							<li>actors;</li>
							<li>screenwriters;</li>
							<li>directors ratings, depending on the genre;</li>
							<li>socio-demographic perception, etc.</li>
						</ul>
					</div>
					<div>
						<p><strong>Inclusion of external factors into the forecast:</strong></p>
						<ul>
							<li>seasonality;</li>
							<li>the competition of major projects and TV shows between channels;</li>
							<li>competition with significant scheduled<br /> events (like Super Bowl or the World Cup);</li>
							<li>other</li>
						</ul>
					</div>
				</div>
			</section>
			<section className={styles.result}>
				<h2>Result</h2>
				<ProjectGrid
					bg="very-dark"
					high
					variant="grid-2"
					listItems={[
						{ title: "A back-test was conducted on more than 80,000 cinema projects with the accuracy of the results of more than 85%." },
						{ title: "Now, a Russian TV Series is being shot based on Movie-Teller’s analytics and forecasting." },
					]}
				/>
			</section>
		</ProjectLayout>

	)
}

export default MovieTeller;
